module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_monocot_leaf_5-e60c8205043eb78411918c9d13aac558.jpg";